<template>
  <section>
    <notifications></notifications>
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-5 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-7 text-right">
          <div class="box-buttons">
            <base-button
              type="outline-neutral"
              @click="mode = 'view'"
              class="min-button"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-view-1 icon-no-margin"></i>
              <strong class="d-lg-block d-none">View</strong>
            </base-button>

            <base-button
              type="outline-neutral"
              @click="mode = 'edit'"
              class="min-button mr-2"
              v-if="mode === 'view'"
            >
              <i class="flaticon-pencil icon-no-margin"></i>
              <strong class="d-lg-block d-none">Edit</strong>
            </base-button>

            <base-button
              type="primary"
              class="min-button"
              v-if="mode === 'edit'"
              @click="saveUser()"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid profile mb-5 forms">
      <div class="row">
        <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="row">
            <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="card">
                <div class="row justify-content-center">
                  <div class="col-lg-12 col-md-12 text-center pb-1">
                    <label
                      for="driver_ProfileImage"
                      class="title-label-np mb-2"
                      v-if="mode === 'edit'"
                    >
                      Profile Image
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <ul class="ul-pop">
                          <li>Allowed Dimensions: 500px x 500px</li>
                          <li>Maximum Size: 2MB</li>
                          <li>Allowed Formats: gif, jpg, jpeg, png</li>
                        </ul>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </label>

                    <div class="imageload3">
                      <div class="image">
                        <div
                          v-if="user.profile.image"
                          v-bind:style="{
                            backgroundImage: 'url(' + user.profile.image + ')'
                          }"
                          class="imgprofile"
                        ></div>

                        <div
                          v-else
                          v-bind:style="{
                            backgroundImage: 'url(' + imageProfile + ')'
                          }"
                          class="imgprofile"
                        ></div>
                      </div>

                      <div class="contentfile3" v-if="mode === 'edit'">
                        <base-dropdown>
                          <base-button
                            slot="title-container"
                            type="primary"
                            class="dropdown-toggle btn-icon-only buttonfiles3"
                          >
                            <i class="flaticon-camera mr-0"></i>
                          </base-button>
                          <span class="dropdown-item">
                            <base-input
                              class="filebutton3"
                              type="file"
                              name="file-1"
                              id="file-1"
                              :accesskey="'profile'"
                              enctype="multipart/form-data"
                              accept="image/jpeg, image/jpg, image/png"
                              @change="readFile"
                            ></base-input>
                            Upload Image
                          </span>
                          <span
                            class="dropdown-item"
                            v-if="picture"
                            @click="clearfile()"
                            >Remove
                          </span>
                        </base-dropdown>
                      </div>
                    </div>
                    <div class="box-profile-one">
                      <h2 class="subtitle mb-1">
                        {{ user.personal_info.first_name }}
                        {{ user.personal_info.last_name }}
                      </h2>
                      <div class="role">
                        {{ getUserRole(user.relationship.type) }}
                      </div>
                    </div>

                    <div class="d-inline-block mt-2 mb-3">
                      <el-tooltip
                        v-if="isConfirmed"
                        content="Account/Email Confirm"
                        placement="bottom"
                      >
                        <div class="badge-profile status-confirmed">
                          <i class="flaticon-check-2 text-success f25 mr-2"></i>
                          <span>Confirmed</span>
                        </div>
                      </el-tooltip>

                      <el-tooltip
                        v-else
                        content="Account/Email Not Confirm"
                        placement="bottom"
                      >
                        <div class="badge-profile status-cancelled">
                          <i class="flaticon-check-2 text-danger f25 mr-2"></i>
                          <span>No Confirmed</span>
                        </div></el-tooltip
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-lg-12 col-md-12">
          <div class="card">
            <h2 class="subtitle">
              Main Contact
            </h2>
            <div class="row mt-2" v-if="mode === 'edit'">
              <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                <base-input
                  v-model.trim="$v.user.personal_info.first_name.$model"
                  id="operator_FirstName"
                  name="operator_FirstName"
                  label="First Name"
                  placeholder="First Name"
                  markrequired
                  format="capitalize"
                  :error="
                    !$v.user.personal_info.first_name.minLength ||
                    $v.user.personal_info.first_name.$error
                      ? `Enter from ${$v.user.personal_info.first_name.$params.minLength.min} to ${$v.user.personal_info.first_name.$params.maxLength.max} letters`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                <base-input
                  v-model.trim="$v.user.personal_info.last_name.$model"
                  id="operator_LastName"
                  name="operator_LastName"
                  label="Last Name"
                  placeholder="Last Name"
                  markrequired
                  format="capitalize"
                  :error="
                    !$v.user.personal_info.last_name.minLength ||
                    $v.user.personal_info.last_name.$error
                      ? `Enter from ${$v.user.personal_info.last_name.$params.minLength.min} to ${$v.user.personal_info.last_name.$params.maxLength.max} letters`
                      : ''
                  "
                />
              </div>
              <div
                class="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-12 form-group"
                v-bind:class="{
                  'is-invalid': $v.user.personal_info.gender.$error
                }"
              >
                <label for="title" class="title-label">Gender</label>
                <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
                  <b-form-radio-group
                    v-model="$v.user.personal_info.gender.$model"
                    :aria-describedby="ariaDescribedby"
                    id="radio-gender"
                    name="radio-gender"
                    buttons
                    button-variant="outline-neutral"
                    size="md"
                    tabindex="3"
                  >
                    <b-form-radio value="male" class="pc-4" tabindex="3"
                      >Mr.</b-form-radio
                    >
                    <b-form-radio value="female" class="pc-4"
                      >Mrs.</b-form-radio
                    >
                    <b-form-radio value="other" class="pc-4">Mx.</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>

                <small
                  class="invalid-feedback mt-1"
                  v-if="$v.user.personal_info.gender.$error"
                  >Select</small
                >
              </div>
              <div
                class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 inputphone form-group"
              >
                <label
                  class="title-label"
                  v-bind:class="{
                    'is-invalid': $v.user.personal_info.phone.$error
                  }"
                  >Contact Number</label
                >
                <vue-tel-input
                  v-model="contactNumber"
                  key="OperatorPhone"
                  inputId="operatorPhone"
                  name="operatorPhone"
                  required
                  mode="international"
                  inputClasses="input no-label no-err"
                  :dynamicPlaceholder="true"
                  :disabledFetchingCountry="true"
                  :validCharactersOnly="true"
                  :wrapperClasses="[
                    $v.user.personal_info.phone.$error ? 'is-invalid' : '',
                    'mb-0'
                  ]"
                  @input="validateContactNumber"
                ></vue-tel-input>
                <small
                  class="invalid-feedback"
                  v-if="$v.user.personal_info.phone.$error"
                  >Enter a valid Phone Number.</small
                >
              </div>

              <div
                class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 inputphone form-group"
              >
                <label class="title-label">Optional Phone</label>
                <vue-tel-input
                  v-model="optionalContactNumber"
                  key="optionalPhone"
                  inputId="optionalPhone"
                  name="optionalPhone"
                  required
                  mode="international"
                  inputClasses="input"
                  :dynamicPlaceholder="true"
                  :disabledFetchingCountry="true"
                  :validCharactersOnly="true"
                  :wrapperClasses="[
                    $v.user.personal_info.optional_phone.$error
                      ? 'is-invalid'
                      : '',
                    'mb-0'
                  ]"
                  @validate="validateOptionalContactNumber"
                ></vue-tel-input>
                <small
                  class="invalid-feedback"
                  v-if="$v.user.personal_info.optional_phone.$error"
                  >Enter a valid phone</small
                >
              </div>
            </div>

            <div class="row" v-if="mode === 'view'">
              <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                <div class="data-block">
                  <span class="title-block">Full Name</span>
                  <span class="content-block"
                    >{{ user.personal_info.first_name }}
                    {{ user.personal_info.last_name }}</span
                  >
                </div>
              </div>

              <div
                class="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-12"
                v-if="user.personal_info.gender"
              >
                <div class="data-block">
                  <span class="title-block">Gender</span>
                  <span class="content-block">{{
                    getGender(user.personal_info.gender)
                  }}</span>
                </div>
              </div>

              <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                <div class="data-block">
                  <span class="title-block">Contact Number</span>
                  <span class="content-block">
                    <a :href="`tel:${contactNumber}`">{{ contactNumber }}</a>
                    <el-tooltip content="Copy" placement="bottom">
                      <span
                        class="curp ml-2"
                        v-clipboard:copy="contactNumber"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onErrorCopy"
                      >
                        <i class="flaticon-copy link ml-0"></i></span
                    ></el-tooltip>
                  </span>
                </div>
              </div>

              <div
                class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12"
                v-if="optionalContactNumber"
              >
                <div class="data-block">
                  <span class="title-block">Optional Phone</span>
                  <span class="content-block">
                    <a :href="`tel:${optionalContactNumber}`">{{
                      optionalContactNumber
                    }}</a>
                    <el-tooltip content="Copy" placement="bottom">
                      <span
                        class="curp ml-2"
                        v-clipboard:copy="optionalContactNumber"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onErrorCopy"
                      >
                        <i class="flaticon-copy link ml-0"></i></span
                    ></el-tooltip>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="card  ">
            <h2 class="subtitle">Account Info</h2>

            <div class="row mt-2" v-if="mode === 'edit'">
              <div class="col-xl-12">
                <div class="row">
                  <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                    <base-input
                      label="Account Email"
                      placeholder="Email Address"
                      id="operator_email_account"
                      name="operator_email_account"
                      maxlength="100"
                      format="lowercase"
                      autocomplete="off"
                      markrequired
                      disabled
                      v-model.trim="$v.user.account.email.$model"
                      :error="getEmailValidationMessage($v.user.account.email)"
                    />
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12"></div>

                  <div class="col-xl-4 col-lg-3 col-md-3 col-sm-6 col-12"></div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <base-input
                      v-model="$v.user.account.password.$model"
                      label="Password"
                      placeholder="Password"
                      name="password"
                      id="password"
                      :type="inputType"
                      autocomplete="new-password"
                      maxlength="20"
                      tabindex="15"
                      class="input-append mb-0"
                      :tooltip="true"
                      titleTooltip='<i class="flaticon-lock mr-2"></i><strong>Strong Password</strong>'
                      contentTooltip='<ul class="ul-pop">
                                  <li>Enter from 8 characters</li>
                                  <li>1 Uppercase Letter</li>
                                  <li>1 Lowercase Letter</li>
                                  <li>1 Number</li>
                                  <li>1 Special Character (Ex. @ # $ %)</li>
                                </ul>'
                      v-bind:class="{
                        'is-invalid': $v.user.account.password.$error
                      }"
                      ><template slot="append">
                        <span @click="seePassword()" class="icon-button"
                          ><i
                            v-bind:class="{
                              'flaticon-view-1': inputType == 'password',
                              'flaticon-hidden': inputType == 'text'
                            }"
                          ></i
                        ></span>
                      </template>
                    </base-input>
                    <small
                      class="invalid-feedback mt--1"
                      v-if="$v.user.account.password.$error"
                      >{{ validatePassword($v.user.account.password) }}</small
                    >
                    <small
                      class="valid-feedback mt-0"
                      v-if="
                        $v.user.account.password.strongPassword &&
                          $v.user.account.password.$model
                      "
                      >Strong Password</small
                    >
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 mt-sm-0 mt-4"
                  >
                    <base-input
                      v-model.trim="$v.repeatPassword.$model"
                      label="Confirm Password"
                      placeholder="Confirm Password "
                      type="password"
                      id="confirm_password"
                      name="confirm_password"
                      maxlength="20"
                      tabindex="16"
                      :error="
                        !$v.repeatPassword.sameAsPassword ||
                        $v.repeatPassword.$error
                          ? `Passwords must be identical`
                          : ''
                      "
                    />
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12  form-group alinmov1"
                  >
                    <base-button
                      type="outline-secondary"
                      class="min-button"
                      @click="autogeneratePass()"
                    >
                      <i class="flaticon-bold-lock"></i>Generate
                    </base-button>

                    <base-button
                      type="outline-secondary"
                      class="min-button"
                      v-clipboard:copy="$v.user.account.password.$model"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onErrorCopy"
                      v-if="$v.user.account.password.$model"
                    >
                      <i class="flaticon-copy"></i>Copy
                    </base-button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-2" v-if="mode === 'view'">
              <div class="col-xl-12">
                <div class="row">
                  <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="data-block">
                      <span class="title-block">Account Email</span>
                      <span class="content-block">
                        <a
                          :href="
                            `https://mail.google.com/mail/?view=cm&fs=1&to=${user.account.email}`
                          "
                          target="_blank"
                          >{{ user.account.email }}</a
                        >
                        <el-tooltip content="Copy" placement="bottom">
                          <span
                            class="curp ml-2"
                            v-clipboard:copy="user.account.email"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onErrorCopy"
                          >
                            <i class="flaticon-copy link ml-0"></i></span
                        ></el-tooltip>
                      </span>
                    </div>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Register Date/Time</span>
                      <span class="content-block">{{ createdAt }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card ">
            <h2 class="subtitle">Address</h2>

            <div class="row mt-2" v-if="mode === 'edit'">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                <base-input
                  v-model="$v.user.address.street.$model"
                  label="Street address, apartment, suite, etc."
                  placeholder="Street address, apartment, suite, etc"
                  id="operator_street"
                  name="operator_street"
                  maxlength="200"
                  tabindex="9"
                  format="capitalize"
                  :error="
                    !$v.user.address.street.minLength ||
                    $v.user.address.street.$error
                      ? `Enter from ${$v.user.address.street.$params.minLength.min} to ${$v.user.address.street.$params.maxLength.max} characters`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                <base-input
                  v-model="$v.user.address.city.$model"
                  label="City"
                  placeholder="City"
                  id="operator_city"
                  name="operator_city"
                  maxlength="45"
                  tabindex="10"
                  format="capitalize"
                  :error="
                    !$v.user.address.city.minLength ||
                    $v.user.address.city.$error
                      ? `Enter from ${$v.user.address.city.$params.minLength.min} to ${$v.user.address.city.$params.maxLength.max} letters`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                <base-input
                  v-model="$v.user.address.state.$model"
                  label="State/Province/Region"
                  placeholder="State/Province/Region"
                  id="operator_state"
                  name="operator_state"
                  maxlength="45"
                  tabindex="11"
                  format="capitalize"
                  :error="
                    !$v.user.address.state.minLength ||
                    $v.user.address.state.$error
                      ? `Enter from ${$v.user.address.state.$params.minLength.min} to ${$v.user.address.state.$params.maxLength.max} letters`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                <base-input
                  v-model.trim="$v.user.address.postal_code.$model"
                  label="Zip/Postal Code"
                  placeholder="Zip/Postal Code"
                  id="operator_zipcode"
                  name="operator_zipcode"
                  maxlength="45"
                  tabindex="12"
                  :error="
                    !$v.user.address.postal_code.minLength ||
                    $v.user.address.postal_code.$error
                      ? `Enter from ${$v.user.address.postal_code.$params.minLength.min} to ${$v.user.address.postal_code.$params.maxLength.max} characters`
                      : ''
                  "
                />
              </div>

              <div class="col-xl-4 col-lg-6 col-md-4 col-sm-4 col-12">
                <WSelect
                  v-bind:class="{
                    'invalid-feedback': $v.user.address.country.$error
                  }"
                  v-model="$v.user.address.country.$model"
                  label="Country"
                  placeholder="Enter a Country"
                  id="operator_country"
                  name="operator_country"
                  class="mb-0"
                  filterable
                  remote
                  reserve-keyword
                  :remote-method="searchCountry"
                  :loading="loading"
                  clearable
                >
                  <el-option
                    v-for="country in countriesOptions"
                    :value="country.name"
                    :label="country.name"
                    :key="country.name"
                  ></el-option>
                </WSelect>
                <small
                  class="invalid-feedback mt-0"
                  v-if="$v.user.address.country.$error"
                  >Enter a Country</small
                >
              </div>
              <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12">
                <base-input
                  v-model.trim="$v.user.address.other_street.$model"
                  id="operator_OtherAddress"
                  name="operator_OtherAddress"
                  label="Other Address"
                  placeholder="Other Address"
                  :error="
                    !$v.user.address.other_street.minLength ||
                    $v.user.address.other_street.error
                      ? `Enter from ${$v.user.address.other_street.$params.minLength.min} to ${$v.user.address.other_street.$params.maxLength.max} characters`
                      : ''
                  "
                />
              </div>
            </div>

            <div class="row" v-if="mode === 'view'">
              <div class="col-xl-12">
                <div class="row">
                  <div
                    class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                    v-if="user.address.street"
                  >
                    <div class="data-block">
                      <span class="title-block"
                        >Street address, apartment, suite, etc.</span
                      >
                      <span class="content-block">{{
                        user.address.street
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                    v-if="user.address.city"
                  >
                    <div class="data-block">
                      <span class="title-block">City</span>
                      <span class="content-block capitalize">{{
                        user.address.city
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                    v-if="user.address.state"
                  >
                    <div class="data-block">
                      <span class="title-block">State/Province/Region</span>
                      <span class="content-block">{{
                        user.address.state
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                    v-if="user.address.postal_code"
                  >
                    <div class="data-block">
                      <span class="title-block">Zip/Postal Code</span>
                      <span class="content-block">{{
                        user.address.postal_code
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                    v-if="user.address.country"
                  >
                    <div class="data-block">
                      <span class="title-block">Country</span>
                      <span class="content-block">{{
                        user.address.country
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                    v-if="user.address.other_street"
                  >
                    <div class="data-block">
                      <span class="title-block">Other Address</span>
                      <span class="content-block">{{
                        user.address.other_street
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
// @ is an alias to /src
import {
  required,
  minLength,
  maxLength,
  email,
  sameAs
} from "vuelidate/lib/validators";
import { helpers } from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import { mapGetters, mapMutations } from "vuex";
import Swal from "sweetalert2";
import { VueTelInput } from "vue-tel-input";
import endpoint from "../../Commons/Services/index";
import WSelect from "@/components/Select";
import lodash from "lodash";
import ManagePaymentMethod from "./Components/PaymentMethods.vue";
import generator from "generate-password";
import moment from "moment";
import upload from "../../Commons/Utility/Upload";
import path from "path";
import { goBack } from "../../../helpers/commons.helpers";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "ManagerProfile",
  data() {
    return {
      user: {
        personal_info: {
          full_name: "",
          first_name: "",
          last_name: "",
          phone: "",
          gender: "",
          optional_phone: ""
        },
        account: {
          email: "",
          password: ""
        },
        profile: {
          image: "",
          status: true
        },
        relationship: {
          owner: "",
          type: "user"
        },
        address: {
          country: "",
          state: "",
          city: "",
          street: "",
          other_street: "",
          postal_code: ""
        }
      },
      loading: false,
      repeatPassword: "",
      typeOptions: [
        { value: "supplier_access", label: "Manager Access" },
        { value: "dispatcher_access", label: "Dispatcher" }
      ],
      userCopy: {},
      saved: false,
      userId: null,
      inputType: "password",
      mode: "view",
      createdAt: "",
      picture: "",
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png"),
      contactNumber: "",
      optionalContactNumber: "",
      countriesOptions: [],
      isConfirmed: false
    };
  },
  async created() {
    var bread = [
      {
        text: "My Profile",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.userId = this.sesion.id;
    await this.getUserById(this.userId);
  },
  methods: {
    async getUserById(userId) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.users.services.getOneUser(
          userId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          let user = data.data;
          this.user.personal_info.first_name = user.personal_info.first_name;
          this.user.personal_info.last_name = user.personal_info.last_name;
          this.user.personal_info.phone = user.personal_info.phone;
          this.user.personal_info.optional_phone =
            user.personal_info.optional_phone;
          this.user.personal_info.gender = user.personal_info.gender;

          this.contactNumber = this.user.personal_info.phone;
          this.optionalContactNumber = this.user.personal_info.optional_phone;

          this.user.address.country = user.address.country;
          this.user.address.state = user.address.state;
          this.user.address.city = user.address.city;
          this.user.address.postal_code = user.address.postal_code;
          this.user.address.street = user.address.street;
          this.user.address.other_street = user.address.other_street;

          this.user.profile.image = user.profile.image;
          this.user.profile.status = user.profile.status;
          this.isConfirmed = user.account.confirmed;
          this.user.account.email = user.account.email;
          this.$v.user.account.email.$model = user.account.email;
          this.lastEmail = user.account.email;

          this.user.relationship.owner = user.relationship.owner;
          this.user.relationship.type = user.relationship.type;

          this.createdAt = moment(user.created_at).format(
            "DD MMM. YYYY - hh:mm A"
          );
          this.userCopy = lodash.cloneDeep(this.user);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "There was an error loading the User, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error loading the User, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async saveUser(route = null) {
      if (!this.$v.user.$invalid) {
        let user = lodash.cloneDeep(this.user);
        user.personal_info.full_name = `${user.personal_info.first_name} ${user.personal_info.last_name}`;
        await this.updateUserById(this.userId, user, route);
      } else {
        this.$v.user.$touch();
        this.$v.repeatPassword.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async updateUserById(userId, user, route = null) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.users.services.updateUser(
          userId,
          user,
          this.sesion.token
        );
        this.setLoad(false);
        this.saved = true;
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The User has been Saved",
            icon: "flaticon-check-3"
          });
          this.mode = "view";
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "There was an error saving the User, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error saving the User, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    validatePassword(password) {
      if (password.$error) {
        if (!password.$minLength) {
          return `Password must have at least ${password.$params.minLength.min} letters.`;
        } else if (password.$required && $model.length < 1) {
          return `Password is required`;
        } else {
          return "Invalid password";
        }
      } else {
        return "";
      }
    },
    autogeneratePass() {
      var password = generator.generate({
        length: 8,
        numbers: true,
        symbols: true,
        lowercase: true,
        uppercase: true,
        strict: true
      });
      this.user.account.password = password;
      this.repeatPassword = password;
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The password has been copied to the clipboard",
        icon: "flaticon-remove"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The password could not be copied",
        icon: "flaticon-remove"
      });
    },
    seePassword() {
      this.inputType = this.inputType == "password" ? "text" : "password";
    },
    goToPreviousPage() {
      goBack(this);
    },
    async detectChanges(to, from, next) {
      let isEqual = lodash.isEqual(this.user, this.userCopy);
      if (!isEqual && !this.saved) {
        let { value, dismiss } = await Swal.fire({
          title: "Important",
          html: "The User has been modified. <br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.saveUser(to.path);
        } else if (dismiss === Swal.DismissReason.cancel) {
          next();
        }
      } else {
        next();
      }
    },
    readFile: async function(event) {
      const [file] = event.target.files;
      if (file.size > 500 * 500) {
        event.preventDefault();
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "The image cannot be larger than 2MB or exceed 500px x 500px dimensions",
          icon: "flaticon-remove"
        });
        this.clearfile();
      } else {
        let urlFile = await upload.uploadFile(
          file,
          upload.buildQueryString(
            upload.getFileData("/users/avatars", path.extname(file.name))
          )
        );
        if (urlFile) {
          this.user.profile.image = urlFile;
          this.picture = urlFile;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The image cannot be larger than 2MB or exceed 500px x 500px dimensions",
            icon: "flaticon-remove"
          });
        }
      }
    },
    clearfile() {
      this.user.profile.image = "";
      this.picture = "";
    },
    searchCountry(value) {
      if (value !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.countriesOptions = this.countries.filter(country => {
            return country.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
          });
        }, 100);
      } else {
        this.countriesOptions = [];
      }
    },
    validateContactNumber(value, payload) {
      let result = payload;
      if (result.isValid) {
        this.user.personal_info.phone = result.number.e164;
      } else {
        this.user.personal_info.phone = null;
      }
    },
    validateOptionalContactNumber(payload) {
      let result = payload;
      if (result.isValid) {
        this.user.personal_info.optional_phone = result.number.e164;
      } else {
        this.user.personal_info.optional_phone = "";
      }
    },
    validateEmail(email) {
      return /^[\w+\-\.]+@[\w-]+(\.[a-zA-Z]{2,}){1,}$/.test(email);
    },
    getEmailValidationMessage(email) {
      if (email.$error) {
        if (!email.required) {
          return "Enter a valid email";
        } else if (!email.email) {
          return "Email is invalid";
        } else if (!email.customValidator) {
          return "Email is already used.";
        }
      } else {
        return "";
      }
    },
    async verifyEmailCustomer(email) {
      try {
        if (email) {
          let { data } = await endpoint.auth.services.checkUniqueEmail(
            email.toLowerCase()
          );
          if (data.status) {
            return !data.data.status;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    validateEmail(email) {
      return /^[\w+\-\.]+@[\w-]+(\.[a-zA-Z]{2,}){1,}$/.test(email);
    },
    getGender(gender) {
      if (gender === "male") {
        return "Male";
      } else if (gender == "female") {
        return "Female";
      } else {
        return "Mx.";
      }
    },
    getUserRole(role) {
      if (role === "supplier_access") {
        return "Manager Access";
      } else {
        return "Dispatcher";
      }
    },
    ...mapMutations(["setLoad", "setItemsBread"])
  },
  validations: {
    user: {
      personal_info: {
        first_name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45),
          ValName
        },
        last_name: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(45),
          ValName
        },
        gender: {
          required
        },
        phone: {
          required,
          minLength: minLength(7),
          maxLength: maxLength(25)
        },
        optional_phone: {
          minLength: minLength(7),
          maxLength: maxLength(25)
        }
      },
      profile: {
        image: {
          required: false
        }
      },
      address: {
        country: {
          ValName,
          minLength: minLength(3),
          maxLength: maxLength(50)
        },
        city: {
          ValName,
          minLength: minLength(3),
          maxLength: maxLength(50)
        },
        state: {
          ValName,
          minLength: minLength(3),
          maxLength: maxLength(50)
        },
        postal_code: {
          minLength: minLength(3),
          maxLength: maxLength(10)
        },
        street: {
          minLength: minLength(5),
          maxLength: maxLength(100)
        },
        other_street: {
          minLength: minLength(5),
          maxLength: maxLength(100)
        }
      },
      account: {
        password: {
          minLength: minLength(8),
          strongPassword(password) {
            if (password === "") {
              return true;
            } else {
              return (
                /[a-z]/.test(password) && // checks for a-z
                /[A-Z]/.test(password) && // checks for A-Z
                /[0-9]/.test(password) && // checks for 0-9
                /\W|_/.test(password) && // checks for special char
                password.length >= 8
              );
            }
          }
        },
        email: {
          required,
          email,
          customValidator: async function(value) {
            if (this.validateEmail(value)) {
              if (this.lastEmail !== value) {
                return await this.verifyEmailCustomer(value);
              } else {
                return true;
              }
            } else {
              return false;
            }
          }
        }
      },
      relationship: {
        type: {
          required
        }
      }
    },
    repeatPassword: {
      sameAsPassword: sameAs(function() {
        return this.user.account.password;
      })
    }
  },
  computed: {
    ...mapGetters(["countries", "sesion", "sigout"])
  },
  components: {
    VueTelInput,
    WSelect,
    ManagePaymentMethod: ManagePaymentMethod
  },
  beforeRouteLeave(to, from, next) {
    if (!this.sigout) {
      this.detectChanges(to, from, next);
    } else {
      next();
    }
  }
};
</script>
